import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Pricing from '../Pricing';
import MaxStay from '../MaxStay';
import { formatDate } from '@spa/shared/utils';
import TenantCounter from '../../TenantCounter';
import MoveInOutPicker from '@spa/shared/components/MoveInOutPicker';
import { Wrapper, Header, HeaderLeft, HeaderRight, DatesTitle } from './styles';
import ArrowNext from '@spa/shared/svg/arrow-next';
import { theme } from '@spa/shared/theme';

const DatePickerDesktop = ({
  guests,
  maxGuests,
  setGuests,
  moveIn,
  moveOut,
  dateRange,
  firstPayment,
  referencePrice,
  maximumStay,
  rents = []
}) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const moveInDate = moveIn ? formatDate(new Date(moveIn), language, 'dd MMM yyyy') : null;
  const moveOutDate = moveOut ? formatDate(new Date(moveOut), language, 'dd MMM yyyy') : null;

  return (
    <Wrapper>
      <Header>
        <HeaderLeft>
          <Pricing firstPayment={firstPayment} referencePrice={referencePrice} />
          <DatesTitle>
            {!moveInDate && !moveOutDate ? (
              <span>{t('Select your move-in date')}</span>
            ) : (
              <Fragment>
                {moveInDate || ''}
                {<ArrowNext color={theme.colors.cornFlowerBlue} />}
                {moveOutDate ?? <span>{t('Select your move-out date')}</span>}
              </Fragment>
            )}
          </DatesTitle>
        </HeaderLeft>
        <HeaderRight>
          {maxGuests > 1 ? <TenantCounter guests={guests} maxGuests={maxGuests} setGuests={setGuests} /> : null}
        </HeaderRight>
      </Header>
      <MoveInOutPicker dateRange={dateRange} rents={rents} />
      {maximumStay && <MaxStay max={maximumStay} />}
    </Wrapper>
  );
};

DatePickerDesktop.propTypes = {
  guests: PropTypes.number.isRequired,
  maxGuests: PropTypes.number.isRequired,
  setGuests: PropTypes.func.isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  dateRange: PropTypes.object.isRequired,
  firstPayment: PropTypes.number.isRequired,
  referencePrice: PropTypes.number.isRequired,
  maximumStay: PropTypes.number,
  rents: PropTypes.array
};

export default DatePickerDesktop;
